import { Card, Typography } from "antd";
import { UsergroupAddOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import "../Pages/CSS/DonnesBases.css";
import ParticipantIpm from "./ParticipantIpm";
import NewParticipantIpm from "./NewParticipantIpm";
import Famille from "./Famille";
import { useLocation } from "react-router-dom";
//import React from 'react'
const { Title } = Typography;

const tabListNoTitle = [
  {
    key: "1",
    label: "Participants IPM",
  },
  {
    key: "2",
    label: "Nouveau Participant IPM",
  },
  {
    key: "3",
    label: "Familles",
  },

];

const Participants = () => {
  //  const [activeTabKey1, setActiveTabKey1] = useState('tab1');
  const [activeTabKey2, setActiveTabKey2] = useState("1");
  const { state } = useLocation();

  const onTab2Change = (key) => {
    setActiveTabKey2(key);
  };

  useEffect(() => {
    console.log(state);
    if (state && state.tab === "famille") {
      setActiveTabKey2("3")
    }
  }, [state])
  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <UsergroupAddOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
          }}
        >
          Participants
        </span>
      </div>
      <Card
        style={{
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
          border: "1px solid #f0f0f0",
          overflow: "hidden",
        }}
        tabList={tabListNoTitle.map((tab) => ({
          ...tab,
          label: (
            <span
              style={{
                fontSize: 14,
                fontWeight: activeTabKey2 === tab.key ? 600 : 500,
                color: activeTabKey2 === tab.key ? "#1890ff" : "#595959",
                transition: "all 0.3s",
              }}
            >
              {tab.label}
            </span>
          ),
        }))}
        activeTabKey={activeTabKey2}
        onTabChange={onTab2Change}
        tabProps={{
          size: "large",
          tabBarStyle: {
            marginBottom: 0,
            paddingLeft: 16,
            paddingRight: 16,
            background: "#fafafa",
            borderBottom: "2px solid #f0f0f0",
          },
        }}
        bodyStyle={{
          padding: "20px",
          minHeight: 500,
          background: "#fff",
        }}
      >
        {activeTabKey2 === "1" && <ParticipantIpm />}
        {activeTabKey2 === "2" && <NewParticipantIpm />}
        {activeTabKey2 === "3" && <Famille />}
      </Card>
    </div>
  );
};

export default Participants;
